(() => {
  if (window.bestLuggageFeedbackInitialized) return;
  window.bestLuggageFeedbackInitialized = true;
  const syncSticky = () => {
    const visible = window.scrollY > 300;
    document.documentElement.classList.toggle('bl-past-sticky-threshold', visible);
    document.querySelectorAll('.nf-sticky, .dpl006-sticky-cta').forEach((bar) => { bar.inert = !visible; });
  };
  syncSticky();
  window.addEventListener('scroll', syncSticky, {passive:true});
  window.addEventListener('pageshow', syncSticky);
  document.addEventListener('DOMContentLoaded', syncSticky);
  let scrollFrame = 0;
  const cancelScroll = () => { cancelAnimationFrame(scrollFrame); scrollFrame = 0; };
  window.addEventListener('wheel', cancelScroll, {passive:true});
  window.addEventListener('touchstart', cancelScroll, {passive:true});
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    let url; try { url = new URL(link.href); } catch { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash || url.hash === '#') return;
    let target; try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch { return; }
    if (!target) return;
    event.preventDefault();
    cancelScroll();
    const start = window.scrollY;
    const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    const end = Math.max(0, Math.min(start + target.getBoundingClientRect().top - offset, document.documentElement.scrollHeight - innerHeight));
    const finish = () => { history.replaceState(history.state, '', url.hash); target.focus({preventScroll:true}); scrollFrame = 0; };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo({top:end, behavior:'instant'}); finish(); return; }
    const began = performance.now();
    const tick = (now) => {
      const progress = Math.min(1, (now - began) / 420);
      const eased = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
      window.scrollTo({top:start + (end - start) * eased, behavior:'instant'});
      if (progress < 1) scrollFrame = requestAnimationFrame(tick); else finish();
    };
    scrollFrame = requestAnimationFrame(tick);
  }, true);
  const active = new Map();
  const reset = (a) => { const s = active.get(a); if (!s) return; clearTimeout(s.timer); a.classList.remove('bl-feedback-loading'); a.removeAttribute('aria-busy'); if (s.label === null) a.removeAttribute('aria-label'); else a.setAttribute('aria-label', s.label); if(s.nodes) a.replaceChildren(...s.nodes); active.delete(a); };
  window.addEventListener('pageshow', () => [...active.keys()].forEach(reset));
  document.addEventListener('click', (event) => {
    const a = event.target.closest('a[href]');
    if (!a || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || a.hasAttribute('download')) return;
    let url; try { url = new URL(a.href); } catch { return; }
    if (!['nobltravel.com','www.nobltravel.com'].includes(url.hostname) || !url.pathname.includes('/products/')) return;
    if (active.has(a)) return;
    const nodes = [...a.childNodes]; const original = document.createElement('span'); original.append(...nodes); a.append(original);
    const loading = document.createElement('span'); loading.className = 'bl-feedback-loading-content'; loading.setAttribute('aria-hidden', 'true');
    const spinner = document.createElement('span'); spinner.className = 'bl-feedback-spinner';
    const label = document.createElement('span'); label.textContent = 'Taking you to NOBL…'; loading.append(spinner, label); a.append(loading);
    active.set(a, {nodes, label:a.getAttribute('aria-label'), timer:setTimeout(() => reset(a), 8000)});
    a.classList.add('bl-feedback-loading'); a.setAttribute('aria-busy','true'); a.setAttribute('aria-label','Taking you to NOBL…');
  });
})();